// axios
import axios from 'axios'
import store from '@/store/store'

function request(request) {
    const axiosSource = axios.CancelToken.source();
    request.cancelToken = axiosSource.token;
    store.dispatch("addRequest", { ...request, cancel: axiosSource.cancel });
    return request;
}

axios.interceptors.request.use(request);
